module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAARCAYAAACvi+4IAAAA80lEQVRIic2WsWpCQRBFryYRtIkIqURsUgUC6Wz9jvxJfiJ12lQWNhaGYJFCgmCXNKmsgoSAlaRIe2R4Uzx8a7tvLpxm2GVPMTu7AurkFngFLk85VAqZeafICuikzq4UMjMAvl3yDWhHEzSugR+XnAOtaILGDbBzySlwFk3QuAP2LvkMNKIJGiPgzyWfTLKwjJWxpBdJHUmP55LCGZbSa1ZKsfKf6oM6sZHz6z04sdscSW4IbF1uBlxEusV9YONyi/KwTi3OzRXw5XLL4ze5bjn7xXy43Dr1q0ltyok9a5ZPoJs61+ZgnXmQ1JV0L2lfEZF0AGFePA5OyvKoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_jiantou.png
// module id = wR29
// module chunks = 4